const DEPLOYMENT_ENVIRONMENTS = {
	BETA: 'app.beta.smartgis.no',
	TEST: 'app.test.smartgis.no',
	STAG: 'app.staging.smartgis.no',
	PROD: 'app.smartgis.no',
	LOCAL: 'localhost:3000'
} as const;

/**
 * Based on the current URL, display:
 * 'beta' text for app.beta.smartgis.no
 * 'test' text for app.test.smartgis.no
 *  no text for app.smartgis.no
 */
function getDeploymentEnvironment(): { text: string; logoImageFilename: string } {
	const currentURL = window.location.host;
	if (currentURL === DEPLOYMENT_ENVIRONMENTS.BETA) {
		return {
			text: '(beta)',
			logoImageFilename: 'smartgis-logo-beta.png'
		};
	} else if (
		currentURL === DEPLOYMENT_ENVIRONMENTS.TEST ||
		currentURL === DEPLOYMENT_ENVIRONMENTS.LOCAL
	) {
		return {
			text: '(test)',
			logoImageFilename: 'smartgis-logo.png'
		};
	} else {
		return {
			text: '',
			logoImageFilename: 'smartgis-logo.png'
		};
	}
}

export { getDeploymentEnvironment };
